import styled from "styled-components";
import {CardBox} from "../../../../basic-components/card/card.box";
import React, {PropsWithChildren} from "react";
import {observer} from "mobx-react";
import {EditPencilIcon} from "../../../../assets/svg/edit-pencil.icon";

const ProfileSectionBox = styled(CardBox)`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0;
`

const SectionHeaderBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${props => props.theme.spacing.flexGap16};
    font-size: ${props => props.theme.fontSize.h3};
    font-weight: ${props => props.theme.fontWeight.medium};
    width: 100%;
    background-color: ${props => props.theme.colors.lightShade};
    padding: ${props => props.theme.spacing.cardDefaultPadding};
`

const SectionContentBox = styled.div`
    width: 100%;
    padding: ${props => props.theme.spacing.cardDefaultPadding};
`

const TitleBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-grow: 1;
`

const EditButtonBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    gap: 4px;
    font-size: ${props => props.theme.fontSize.h5};
`

const EditButtonTextBox = styled.span`
    &:hover {
        text-decoration: underline;
    }
`

interface ProfileSectionComponentProps extends PropsWithChildren {
    title: string | React.ReactNode;
    editButtonContent?: string | React.ReactNode;
    onEditButtonClick?: () => void;
}



export const AgencyProfileSectionComponent: React.FC<ProfileSectionComponentProps> = observer((props) => {
    const renderEditButton = () => {
        if(props.editButtonContent) {
           return (
               <EditButtonBox onClick={props.onEditButtonClick}>
                   <EditPencilIcon size={0.8}/>
                   <EditButtonTextBox>
                       {props.editButtonContent}
                   </EditButtonTextBox>

               </EditButtonBox>
           );
        }
        return null;
    }
    return (
        <ProfileSectionBox>
            <SectionHeaderBox>
                <TitleBox>
                    {props.title}
                </TitleBox>
                {renderEditButton()}
            </SectionHeaderBox>
            <SectionContentBox>
                {props.children}
            </SectionContentBox>
        </ProfileSectionBox>
    )
})
